import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { Period } from '../entity/period';
import { Rule } from '../entity/rule';
import { toRuleTypeTransformer } from '../state/transformers/transformers';
import { RuleType } from '../state/types';
import { BLService } from './bl.service';

@Injectable()
export class PeriodService extends BLService {
  private RESOURCE_ENDPOINT = 'period';

  getPeriods(): Observable<Period[]> {
    return this.httpGet<Period[]>(this.RESOURCE_ENDPOINT);
  }

  getAvailableRules(period: Period): Observable<Rule[]> {
    return this.httpGet<Rule[]>(`${this.RESOURCE_ENDPOINT}/template/${period.name}`);
  }

  getAvailableRuleTypes(period: Period): Observable<RuleType[]> {
    return this.getAvailableRules(period).pipe(map((rules) => rules.map(toRuleTypeTransformer.transform)));
  }
}
